import React from 'react';

// The single source of truth for the hub's content edges. The top bar's contents and every
// page are wrapped in this, so they share the same left/right edges and nothing appears to
// grow or shrink when navigating between the landing page and a content page. Change the
// padding here and the whole hub follows.
//
// No max-width, by decision on 2026-08-09: the hub runs edge-to-edge on every viewport
// rather than capping at the design system's 82rem shell and centering with margins either
// side. The logo sits at the true left edge and the menu/Member Portal at the true right
// edge; every page's content spans the same full width beneath it.
//
// The desktop padding is 2rem to match the system's gutter. It is written as `lg:px-8`
// rather than `px-gutter` because the spacing token was never added to this surface's
// Tailwind config — only the colours, fonts, steps, widths and motion were. Same value,
// and the config is where to fix that properly.
interface HubContainerProps {
  children: React.ReactNode;
  className?: string;
}

const HubContainer: React.FC<HubContainerProps> = ({ children, className = '' }) => (
  <div className={`w-full px-4 lg:px-8 ${className}`}>{children}</div>
);

export default HubContainer;
